import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../services/apiClient";
import { GetAllMatter, Page, Size } from "../../config/config";

// Async thunk to fetch all matters
let CurrentPage = Number(Page);
export const fetchAllMatters = createAsyncThunk(
	"matters/fetchAllMatters",
	async (Param: any, { rejectWithValue }) => {

		try {
			CurrentPage = Param.NextPage
			// apiClient injects the current Access Token automatically (and
			// transparently refreshes it via the Public API if expired) -
			// see src/services/apiClient.ts / tokenManager.ts.
			const response = await apiClient.get(GetAllMatter + CurrentPage + "/" + Size,
				{
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'mode': 'outlook'
					},
				}
			);
			 //console.log('matter response', response.data)
			return response.data; // Return the fetched data
		} catch (error) {
			return rejectWithValue(error.response.data); // Return error message
		}
	}
);

const initialState = {
	matters: [],
	loading: false,
	error: null,
	page: 1,
	pageCount: 1,
};

const matterSlice = createSlice({
	name: "matters",
	initialState,
	reducers: {
		clearMatters: () => initialState, // This resets the state to the initial state
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllMatters.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(fetchAllMatters.fulfilled, (state, action) => {
				state.loading = false;

				if (action.payload.page === 1) {
					state.matters = action.payload.data;
				} else {
					state.matters = [...state.matters, ...action.payload.data];
				}

				state.pageCount = action.payload.pageCount;
				state.page = action.payload.page;

				// Sort ONCE, when the final page lands - not on every page.
				// Sorting here per-page meant re-sorting a growing array ~20
				// times for a 50k matter list, each pass paying for
				// localeCompare (one of the slowest string operations in JS).
				// Nothing reads this list in a user-visible way before the run
				// completes: the Matter dropdown is blocked while
				// `page < pageCount` (see EmailLog.tsx).
				if (action.payload.page >= action.payload.pageCount) {
					state.matters.sort((a, b) =>
						a.matter.toLowerCase().localeCompare(b.matter.toLowerCase()));
				}
			})
			.addCase(fetchAllMatters.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload;
			});
	},
});

export const { clearMatters } = matterSlice.actions;
export default matterSlice.reducer;